import { runPlayStopInteraction } from "../../core/play-stop-interaction.js";

export const meta = Object.freeze({
  id: "play-button",
  label: "Play-/Stop-Button",
  duration: 1600,
  description: "Hover zeigt Play; Klick wechselt zu einem roten Stop-Zustand, der zweite Klick setzt Orbi zurück.",
  tags: ["expression", "cta", "play", "stop", "interactive", "event-driven"],
  managesOwnLoop: true,
});

export async function run(context) {
  await runPlayStopInteraction(context);
}
